module.exports = __webpack_public_path__ + "img/Award.449157e4.jpg";